import Vue from "vue";

const filterDialogHoc = component => {
  return Vue.component("filterDialogHoc", {
    render(createElement) {
      return createElement(component, {
        props: this.filterDialogProps,
        on: this.filterDialogEvents
      });
    },
    props: {
      closeFunction: {
        type: Function,
        required: true
      },
      filters: {
        type: Object
      },
      showRatings: {
        type: Boolean,
        default: true
      },
      showCommentsOptions: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        payload: {
          cities: [],
          groups: [],
          rating: [],
          gmbAddressIds: [],
          facilitiesIds: [],
          comment: null,
          addedToGoogle: null,
          writtenWithAI: null,
          googleMapsClicked: null,
          addedToApple: null,
          addedToAppleClicked: null
        }
      };
    },
    created() {
      if (this.filters) {
        Object.entries(this.filters).forEach(([key, name]) => {
          this.payload[key] = name;
        });
      }
    },
    computed: {
      filterDialogProps() {
        const { payload } = this;
        return {
          showCommentsOptions: this.showCommentsOptions,
          showRatings: this.showRatings,
          gmbAddressesIds: this.getFilterData(payload.gmbAddressIds),
          facilitiesIds: this.getFilterData(payload.facilitiesIds),
          cities: !Array.isArray(payload.cities)
            ? payload.cities.split(",")
            : payload.cities,
          facilitiesGroupsIds: this.getFilterData(payload.groups),
          rating: this.getFilterData(payload.rating),
          chosenOnlyComments: this.getBooleanValueFromString(payload.comment),
          chosenSearchType: payload.searchType,
          handleClose: this.closeFunction,
          showAccurateReviewsFilter: false,
          showReviewBoosterFilters: true,
          chosenAddedToGoogle: this.getBooleanValueFromString(
            payload.addedToGoogle
          ),
          chosenWrittenWithAI: this.getBooleanValueFromString(
            payload.writtenWithAI
          ),
          chosenGoogleMapsClicked: this.getBooleanValueFromString(
            payload.googleMapsClicked
          )
        };
      },
      filterDialogEvents() {
        const { payload } = this;
        return {
          setGmbAddressesIds(e) {
            payload.gmbAddressIds = e;
          },
          setFacilitiesIds(e) {
            payload.facilitiesIds = e;
          },
          setCities(e) {
            payload.cities = e;
          },
          setFacilitiesGroupsIds(e) {
            payload.groups = e;
          },
          setRatingValues(e) {
            payload.rating = e;
          },
          setOnlyComments(e) {
            payload.comment = e;
          },
          setSearchType(e) {
            payload.searchType = e;
          },
          setAddedToGoogle(e) {
            payload.addedToGoogle = e;
          },
          setWrittenWithAI(e) {
            payload.writtenWithAI = e;
          },
          setGoogleMapsClicked(e) {
            payload.googleMapsClicked = e;
          },
          change: () => {
            this.$emit("apply-filters", this.payload);
          }
        };
      }
    },
    methods: {
      getFilterData(value) {
        return Array.isArray(value)
          ? value
          : value.split(",").map(item => +item);
      },
      getBooleanValueFromString(value) {
        if (value === "true") {
          return true;
        } else if (value === "false") {
          return false;
        }
        return value;
      }
    }
  });
};

export default filterDialogHoc;
